// extracted by mini-css-extract-plugin
export default {"personaSelect":"PersonaSelect_personaSelect__i8XGM"};